import React from 'react';
import {
  Typography,
  Box,
  Button,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon
} from '@mui/icons-material';

const SubscriptionSection = ({ userProfile, expandedSection, onAccordionChange, isMobile }) => {
  const getSubscriptionColor = () => {
    if (!userProfile.subscription) return 'default';
    
    const { plan, active, endDate } = userProfile.subscription;
    const end = endDate?.toDate ? endDate.toDate() : new Date(endDate);
    const now = new Date();
    
    if (plan === 'trial') {
      const daysLeft = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
      if (!active || daysLeft <= 0) return 'error';
      if (daysLeft <= 3) return 'warning';
      return 'info';
    }
    
    return active ? 'success' : 'error';
  };

  const colors = {
    primary: '#000000',
    secondary: '#6B7280',
    accent: '#F5F5DC',
    background: '#F8F9FA',
    surface: '#FFFFFF',
    border: '#E5E7EB'
  };

  const content = (
    <Box sx={{ p: { xs: 0.5, sm: 1, md: 4 } }}>
      {!isMobile && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: { xs: 2, md: 3 }, flexWrap: 'wrap', gap: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: colors.primary,
              fontSize: { xs: '1.125rem', md: '1.25rem' }
            }}
          >
            Abonnement
          </Typography>
        </Box>
      )}

      <Typography 
        variant="body2" 
        sx={{
          color: colors.secondary,
          mb: { xs: 2, md: 3 },
          lineHeight: 1.6,
          fontSize: { xs: '0.875rem', md: '1rem' }
        }}
      >
        Gérez votre abonnement BookingBarber
      </Typography>

      {userProfile.subscription?.plan === 'trial' && (
        <Alert 
          severity="warning" 
          sx={{
            mb: { xs: 2, md: 3 },
            borderRadius: 2,
            '& .MuiAlert-message': {
              fontSize: { xs: '0.875rem', md: '1rem' }
            }
          }}
        >
          Votre période d'essai se termine bientôt. Souscrivez à un abonnement pour continuer.
        </Alert>
      )}

      <Button
        variant="contained"
        fullWidth
        sx={{ 
          backgroundColor: colors.primary,
          color: colors.surface,
          py: { xs: 1.5, md: 2 },
          fontSize: { xs: '0.875rem', md: '1rem' },
          fontWeight: 600,
          borderRadius: 2,
          textTransform: 'none',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          '&:hover': {
            backgroundColor: '#333333',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }}
      >
        {userProfile.subscription?.plan === 'trial' ? 'Souscrire maintenant' : 'Gérer l\'abonnement'}
      </Button>
    </Box>
  );

  if (isMobile) {
    return (
      <Accordion 
        expanded={expandedSection === 'subscription'} 
        onChange={onAccordionChange('subscription')}
        elevation={0}
        sx={{ 
          '&:before': { display: 'none' },
          borderRadius: '0 !important'
        }}
      >
        <AccordionSummary 
          expandIcon={<ExpandMoreIcon />}
          sx={{
            px: { xs: 0.5, sm: 1, md: 3 },
            py: { xs: 1, md: 2 },
            minHeight: 'auto',
            '&.Mui-expanded': {
              minHeight: 'auto'
            },
            '& .MuiAccordionSummary-content': {
              margin: 0,
              '&.Mui-expanded': {
                margin: 0
              }
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', pr: 1 }}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600,
                color: colors.primary,
                fontSize: '1.125rem'
              }}
            >
              Abonnement
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          {content}
        </AccordionDetails>
      </Accordion>
    );
  }

  return content;
};

export default SubscriptionSection;